import React from "react";
import { Link } from 'react-router-dom';
import Header from '../common/header/Header';
import SEO from '../common/SEO';

const Aboutbh = () => {
    return (
        <>
            <SEO title="Aboutbh - East Coast Coders LLC" />
            <main className="main-wrapper">
                <Header />

                {/* Centered Content */}
                <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh', padding: '2rem', marginTop: '80px' }}>
                    <div className="text-center" style={{ maxWidth: '800px', width: '100%' }}>

                        {/* Aboutbh Component from Figma */}
                        <div className="mb-5">
                            <p style={{
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 'normal',
                                fontSize: '50px',
                                color: '#000000',
                                textAlign: 'center',
                                margin: '0',
                                lineHeight: 'normal'
                            }}>
                                Aboutbh
                            </p>
                            <p style={{
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 'normal',
                                fontSize: '1.1rem',
                                color: '#555',
                                textAlign: 'center',
                                margin: '1rem 0 0'
                            }}>
                                Leveraging AI to deliver smarter business solutions.
                            </p>
                        </div>

                        {/* Back to Home Button */}
                        <div>
                            <Link
                                to="/"
                                className="axil-btn btn-fill-primary"
                                style={{
                                    padding: '15px 30px',
                                    fontSize: '1.1rem',
                                    textDecoration: 'none',
                                    display: 'inline-block'
                                }}
                            >
                                Back to Home
                            </Link>
                        </div>

                    </div>
                </div>

            </main>
        </>
    );
};

export default Aboutbh;
